import React from "react";
import { useSelector } from "react-redux";
import { Wrapper } from "./funded.styles";
import { GradientButton } from "./gradientButton";
import environmentSettings from "../../../constants/environmentSettings";
import thumbsUp from "../animatedGifs/tracker-approved-optimised.gif";

export const Funded = () => {
  const { status } = useSelector((state) => state.trackingStatus.value);

  return (
    <Wrapper>
      {status === "Idle" ? (
        <div className="funded-idle">
          <p>At the moment, you have no application waiting to be processed.</p>
          <p>To view your current loan, please login to your portal.</p>
        </div>
      ) : (
        <div className="funded-deposited">
          <img className="animated-gif-thumb" src={thumbsUp} alt="deposited" />
          <h3>Congratulations!</h3>
          <p>Your funds have been deposited to your nominated account.</p>
        </div>
      )}
      <GradientButton
        elementType="a"
        href={environmentSettings.portalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="portal-button"
        buttonText="Login to your Portal"
      />
    </Wrapper>
  );
};
